export const IMAGES = {
  hero: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/084bsfr3_IMG_6883.webp",
  story1: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/1i9cgk5f_Screenshot%202026-08-09%20at%2010.46.54%E2%80%AFPM.png",
  story2: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/adcanvwc_Screenshot%202026-08-09%20at%2010.48.43%E2%80%AFPM.png",
  story3: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/73ee78zn_Screenshot%202026-08-09%20at%2010.48.25%E2%80%AFPM.png",
  story4: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/49bkkzlg_Screenshot%202026-08-09%20at%2010.47.55%E2%80%AFPM.png",
  dateNight: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/97j76frm_Screenshot%202026-08-10%20at%2012.30.21%E2%80%AFPM.png",
  venue: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/2c442f670810f115_Screenshot%202026-10-27%20at%204.56.36%E2%80%AFPM.webp",
  reception: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bear: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/7nvcmdby_Facetune_11-06-2026-13-54-22.webp",
  bearPortrait: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/y2hvl2o0_IMG_6761.jpg",
  bearSelfie: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/zobyalwm_IMG_7417.jpg",
  paris: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/ra5n0rbt_IMG_7419.jpg",
  pool: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/7y9aznnf_IMG_7418.jpg",
};

export const WEDDING_DATE = new Date("2027-03-27T17:00:00-04:00");

export const CHAPTERS = [
  {
    n: "01",
    title: "A Simple Hello",
    text: "Our story began on December 10, 2022, with a simple hello at a bar in Denver, Colorado. A girl from Monterrey, MX, and a guy from Raleigh, NC — yet somehow life brought us together in the most unexpected place. A moment we now call fate.",
  },
  {
    n: "02",
    title: "Building a Life",
    text: "From that night on, we've been inseparable. Together we've built a life filled with adventure, shared dreams, and our sweet Saint Bernard, Bear, who made our little family complete.",
  },
  {
    n: "03",
    title: "The Question",
    text: "In July 2025 we moved to Florida, and on November 16, 2025, he proposed — beginning the next chapter of our story.",
  },
  {
    n: "04",
    title: "Forever",
    text: "Now we can't wait to celebrate our love and the start of forever with the people who mean the most to us.",
  },
];

export const EVENTS = [
  {
    day: "Friday",
    date: "March 26, 2027",
    title: "Welcome Party",
    place: "Loews Hotel Rooftop",
    address: "Miami Beach, Florida",
    time: "Evening — time to follow",
    note: "Kick off the weekend with cocktails, ocean views, and the people we love most.",
  },
  {
    day: "Saturday",
    date: "March 27, 2027",
    title: "The Wedding",
    place: "The Deering Estate",
    address: "16701 SW 72nd Ave, Miami, FL 33157",
    time: "Ceremony at 5:00 PM",
    note: "Ceremony, cocktails, dinner & dancing under the Miami sky.",
    maps: "https://www.google.com/maps/dir/?api=1&destination=16701+SW+72nd+Ave,+Miami,+FL+33157",
  },
  {
    day: "Sunday",
    date: "March 28, 2027",
    title: "Farewell Brunch",
    place: "A Nearby Restaurant",
    address: "Details to follow",
    time: "Late morning",
    note: "One last gathering before we all say hasta pronto.",
  },
];

export const FAQS = [
  {
    q: "When should I RSVP by?",
    a: "Kindly let us know if you'll join us by February 1, 2027. Our day wouldn't be the same without you.",
  },
  {
    q: "What is the dress code?",
    a: "Formal attire. Think elegant garden evening — the ceremony and reception take place outdoors at The Deering Estate, so consider comfortable footwear for grass and stone paths.",
  },
  {
    q: "Can I bring a plus one?",
    a: "Due to venue capacity, we can only accommodate guests named on your invitation. Your invitation will indicate the number of seats reserved for you.",
  },
  {
    q: "Are children welcome?",
    a: "We love your little ones, but our celebration will be an adults-only evening — with the exception of immediate family.",
  },
  {
    q: "What will the weather be like?",
    a: "Miami in late March is beautiful — typically mid-70s to low-80s °F with warm evenings. A light layer for after sunset is a good idea.",
  },
  {
    q: "Is there parking at the venue?",
    a: "Yes, complimentary parking is available at The Deering Estate. We'll also share ride-share and shuttle details closer to the date.",
  },
];

export const TRAVEL = [
  {
    title: "Getting Here",
    lines: [
      "Miami International Airport (MIA) — about 30 minutes from the venue.",
      "Fort Lauderdale (FLL) — a good alternative, about an hour away.",
      "Ride-shares are reliable throughout Miami; a rental car is handy if you plan to explore.",
    ],
  },
  {
    title: "Where to Stay",
    lines: [
      "Loews Miami Beach Hotel — home of our Friday welcome party, right on the ocean.",
      "Room block details and preferred rates are coming soon.",
      "The Palmetto Bay and Coral Gables areas are closest to The Deering Estate.",
    ],
  },
  {
    title: "While You're in Miami",
    lines: [
      "Wander the streets and cafecito windows of Little Havana.",
      "Art Deco strolls and beach mornings in South Beach.",
      "The Wynwood Walls, Vizcaya Museum & Gardens, and endless good food.",
    ],
  },
];
